<script setup lang="ts">
/**
 * Native About window (#350), route `/about`. Rust opens it at 360x400 from
 * the home page label, the app or Help menu, and the narrow More menu.
 * Escape closes it.
 */
import { onBeforeUnmount, onMounted } from "vue";
import { isTauri } from "../lib/runtime";
import { closeAboutWindow } from "../lib/tauri/about";
import AboutPanel from "./AboutPanel.vue";

function onKeydown(event: KeyboardEvent): void {
  if (event.key !== "Escape" || isTauri() === false) return;
  event.preventDefault();
  void closeAboutWindow();
}

onMounted(() => {
  window.addEventListener("keydown", onKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKeydown);
});
</script>

<template>
  <main class="about-page zw-paper-surface">
    <h1 class="about-page-title">About Zephyrwrite</h1>
    <AboutPanel host="window" :check-on-open="false" />
  </main>
</template>

<style scoped>
.about-page {
  box-sizing: border-box;
  min-height: 100vh;
  overflow: auto;
  padding: 1.5rem 1.25rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.about-page-title {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
</style>
